import React, { FC } from 'react'

import { MagnifyingGlassIcon, XCircleIcon } from '@heroicons/react/20/solid'
import { RectangleStackIcon } from '@heroicons/react/24/outline'
import classNames from 'classnames'
import { debounce } from 'lodash'

import { useAppDispatch, useAppSelector } from '@/client/hooks'
import { setSearch, setSearchAllFolders } from '@/features/FileManager/fileManagerSlice'

export const SearchFilter: FC = () => {
  const dispatch = useAppDispatch()
  const search = useAppSelector((state) => state.fileManager.search)
  const searchAllFolders = useAppSelector((state) => state.fileManager.searchAllFolders)

  const handleSearch = debounce((value: string) => {
    dispatch(setSearch(value))
  }, 400)

  const buttonClasses = classNames({
    'p-1 rounded cursor-pointer border-2': true,
    'bg-sky-400 stroke-white border-black': searchAllFolders,
    'stroke-gray-400 border-gray-200': !searchAllFolders,
  })

  return (
    <div className='flex items-center gap-2'>
      <MagnifyingGlassIcon width={20} />
      <div className='relative'>
        <input
          type='text'
          key={search}
          placeholder='Search folder'
          onChange={({ target: { value } }) => handleSearch(value)}
          defaultValue={search || ''}
          className='text-xs border-1 border-sky-200 py-1.5 px-1'
        />
        {search?.length > 0 && (
          <div
            onClick={() => handleSearch('')}
            className='absolute flex h-full items-center top-0 right-1 opacity-60 z-10'
          >
            <XCircleIcon
              width={20}
              className='cursor-pointer'
            />
          </div>
        )}
      </div>

      <div
        className={buttonClasses}
        title='Search across all folders'
      >
        <RectangleStackIcon
          width={20}
          stroke='inherit'
          onClick={() => dispatch(setSearchAllFolders(!searchAllFolders))}
        />
      </div>
    </div>
  )
}
